import { render, staticRenderFns } from "./Suit.vue?vue&type=template&id=0891ef3d&scoped=true&"
import script from "./Suit.vue?vue&type=script&lang=js&"
export * from "./Suit.vue?vue&type=script&lang=js&"
import style0 from "./Suit.vue?vue&type=style&index=0&id=0891ef3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0891ef3d",
  null
  
)

export default component.exports